import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Customer, singleCustomer, DeliveryAddress } from '../customer-search/customer-search.component';
import * as api from '../../shared/api/apihandler';

@Component({
  selector: 'app-change-customer-modal',
  templateUrl: './change-customer-modal.component.html',
  styleUrls: ['./change-customer-modal.component.css']
})
export class ChangeCustomerModalComponent {
  form = new CustomerChangeForm();
  roadSize = 10;
  addresses = [];
  addressesSame = true;
  settings = new Settings();
  chosenCustomer: singleCustomer;
  chosenDeliveryAddress = new DeliveryAddress();
  manualInputInvoiceCountryCode = '+45';
  manualInputDeliveryCountryCode = '+45';
  manualInputCustomerCountryCode = '+45';


  @Input('case') case: string;
  @Output('update') update = new EventEmitter();
  constructor(private httpClient: HttpClient) { }

  customerSearchToForm(data: singleCustomer) {
    this.chosenCustomer = data;

    console.log('Single Customer', data)

    let c = this.form.customer;
    c.customerName = data.customerName;
    c.customerAddress = data.customerAddress;
    c.customerZipCode = data.customerZipCode;
    c.customerCity = data.customerCity;
    c.customerMobile = data.customerPhone;
    c.customerNumber = data.customerNumber;
    this.form.customerId = data.customerId;
    this.form.deliveryId = data.deliveryId;

    let i = this.form.invoice;
    i.invoiceName = data.invoiceName;
    i.invoiceAddress = data.invoiceAddress;
    i.invoiceZipCode = data.invoiceZipCode;
    i.invoiceCity = data.invoiceCity;
    i.invoiceMobile = data.invoicePhone;
    i.invoiceEmail = data.invoiceEmail;

    let d = this.form.delivery;
    if (data.addresses.length > 0) {
      let first = data.addresses[0];
      d.name = first.customerName;
      d.address = first.customerAddress;
      d.zipCode = first.customerZipCode;
      d.city = first.customerCity;
      d.email = first.customerMail;
      d.mobile = first.customerPhone;
    }
    else {
      d.name = data.customerName;
      d.address = data.customerAddress;
      d.zipCode = data.customerZipCode;
      d.city = data.customerCity;
      d.email = data.customerMail;
      d.mobile = data.customerPhone;
    }
    
   
  }

  newCustomer() {
    this.form = new CustomerChangeForm();
    this.chosenCustomer = null;
    this.settings.show.manualCustomer = true;
    this.settings.show.manualMode = true;
    this.settings.type.invoiceIsManual = true;
    this.settings.type.deliveryIsManual = true
    this.settings.type.customerIsManual = true;
    this.settings.show.alternateAddresses = false;
  }

  startAnew() {
    this.form = new CustomerChangeForm();
    this.settings.show.reset();
    this.settings.type.reset();
  }

  clearDeliveryAddress() {
    this.form.delivery = new Address();
  }

  createManualDelivery() {
    this.settings.show.manualDelivery = true;
    this.form.deliveryId = null;
  }

  changeCustomer() {
    if (this.validate() == true) {
      console.log(this.form)
      const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
      this.httpClient.put(api.jubloApi + 'api/Website/Offer/AddCustomerToOffer/' + this.case, this.form, { headers }).subscribe((reply) => {
        this.update.emit(true);
        this.form = new CustomerChangeForm();
        this.settings.show.reset();
        this.settings.type.reset();
      })
    }
  }

  changeDeliveryAddress(data: DeliveryAddress) {
    let d = this.form.delivery;
    d.name = data.customerName;
    d.address = data.customerAddress;
    d.zipCode = data.customerZipCode;
    d.city = data.customerCity;
    d.email = data.customerMail;
    d.mobile = data.customerPhone;
    this.form.deliveryId = data.deliveryId;
    this.settings.show.alternateAddresses = false;
  }

  validate(): boolean {
    let t = this.settings.type;
    let c = this.form.customer;
    let i = this.form.invoice;
    let d = this.form.delivery;
    if (!t.invoiceIsManual && !t.deliveryIsManual ) { return true }
    if (!t.invoiceIsManual && t.deliveryIsManual) {
      if (this.validateDelivery()) {
        d.mobile = this.manualInputDeliveryCountryCode + d.mobile;
        return true
      }
      else {
        //Do something else
        return false
      }
    }
    if (t.invoiceIsManual && t.deliveryIsManual) {
      if (!this.validateCustomer()) {
        return false
      }
      else if (this.validateInvoice() && this.validateDelivery()) {
        i.invoiceMobile = this.manualInputInvoiceCountryCode + i.invoiceMobile;
        d.mobile = this.manualInputDeliveryCountryCode + d.mobile;
        c.customerMobile = this.manualInputCustomerCountryCode + c.customerMobile
        return true
      }
      else {
        let d = this.form.delivery;
        let i = this.form.invoice;
        if (i.invoiceName == '' && i.invoiceAddress == '' && i.invoiceZipCode == '' && i.invoiceCity == '' && i.invoiceEmail == '' && i.invoiceMobile == '') {
          this.copyCustomerAddressToInvoice();
        }
        if (d.name == '' && d.address == '' && d.zipCode == '' && d.city == '' && d.email == '' && d.mobile == '') {
          this.copyCustomerAddressToDelivery();
          return true
        }
        else { return false }
      }
    }
  }

  validateCustomer(): boolean {
    if (!this.settings.type.customerIsManual) { return true }
    let c = this.form.customer;
    if (c.customerName != '' && c.customerAddress != '' && c.customerZipCode != '' && c.customerCity != '' && c.customerEmail != '' && c.customerMobile != '') { return true }
    else { return false }
  }

  validateInvoice(): boolean {
    if (!this.settings.type.invoiceIsManual) { return true }
    let i = this.form.invoice;
    if (i.invoiceName != '' && i.invoiceAddress != '' && i.invoiceZipCode != '' && i.invoiceCity != '' && i.invoiceEmail != '' && i.invoiceMobile != '') { return true }
    else { return false }
  }

  validateDelivery(): boolean {
    let d = this.form.delivery;
    if (d.name != '' && d.address != '' && d.zipCode != '' && d.city != '' && d.email != '' && d.mobile != '') { return true }
    else { return false }
  }

  async copyCustomerAddressToDelivery() {
    let i = this.form.customer;
    let d = this.form.delivery;
    d.name = i.customerName;
    d.address = i.customerAddress;
    d.zipCode = i.customerZipCode;
    d.city = i.customerCity;
    d.email = i.customerEmail;
    d.mobile = this.manualInputCustomerCountryCode + i.customerMobile
  }

  copyCustomerAddressToInvoice() {
    let i = this.form.invoice;
    let c = this.form.customer;
    i.invoiceName = c.customerName;
    i.invoiceAddress = c.customerAddress;
    i.invoiceZipCode = c.customerZipCode;
    i.invoiceCity = c.customerCity;
    i.invoiceMobile = this.manualInputCustomerCountryCode + c.customerMobile

  }

  copyFrom(from, to) {
    let f = new Address();
    let cCode = '';
    switch (from) {
      case ('customer'): {
        let c = this.form.customer;
        f.name = c.customerName;
        f.address = c.customerAddress;
        f.zipCode = c.customerZipCode;
        f.city = c.customerCity
        f.email = c.customerEmail;
        f.mobile = c.customerMobile;
        cCode = this.manualInputCustomerCountryCode;
        break
      }
      case ('invoice'): {
        let i = this.form.invoice;
        f.name = i.invoiceName;
        f.address = i.invoiceAddress;
        f.zipCode = i.invoiceZipCode;
        f.city = i.invoiceCity;
        f.email = i.invoiceEmail;
        f.mobile = i.invoiceMobile;
        cCode = this.manualInputInvoiceCountryCode;
        break
      }
      case ('delivery'): {
        f = this.form.delivery;
        cCode = this.manualInputDeliveryCountryCode;
        break
      }
    }
    this.copyTo(f,cCode, to)
  }

  copyTo(f: Address, code, to) {
    switch (to) {
      case ('customer'): {
        let c = this.form.customer;
        c.customerName = f.name;
        c.customerAddress = f.address;
        c.customerZipCode = f.zipCode;
        c.customerCity = f.city;
        c.customerEmail = f.email;
        c.customerMobile = f.mobile;
        this.manualInputCustomerCountryCode = code;
        break
      }
      case ('invoice'): {
        let i = this.form.invoice;
        i.invoiceName = f.name;
        i.invoiceAddress = f.address;
        i.invoiceZipCode = f.zipCode;
        i.invoiceCity = f.city;
        i.invoiceEmail = f.email;
        i.invoiceMobile = f.mobile;
        this.manualInputInvoiceCountryCode = code;
        break
      }
      case ('delivery'): {
        this.form.delivery = f;
        this.manualInputDeliveryCountryCode = code;
        break
      }
    }
  }

  addressLookup() {
    let post = '';
    if (this.settings.show.manualInvoice) {
      if (this.form.customer.customerZipCode != '') { post = '&postnr=' + this.form.customer.customerZipCode }
      this.dawaAdresse(this.form.customer.customerAddress, post)
    }
    else {
      if (this.form.delivery.zipCode != '') { post = '&postnr=' + this.form.delivery.zipCode }
      this.dawaAdresse(this.form.delivery.address, post)
    }
  }

  dawaAdresse(address, zip) {
    this.httpClient.get('https://dawa.aws.dk/adresser/autocomplete?q=' + address + zip).subscribe((data: Array<DAWA>) => {
      console.log(data)
      let road = new Set();
      let roadNumber = [];

      for (var i in data) {
        road.add(data[i].adresse.vejnavn);
        let vej = data[i].adresse.vejnavn;

        if (data[i].adresse.husnr) { vej = vej + ' ' + data[i].adresse.husnr; }
        if (data[i].adresse.etage) { vej = vej + ', ' + data[i].adresse.etage + '.'; }
        if (data[i].adresse.dør) { vej = vej + ' ' + data[i].adresse.dør + '.'; }

        roadNumber.push(vej);
      }
      if (road.size > 1) { this.addresses = Array.from(road); this.roadSize = road.size }
      if (road.size == 1 && roadNumber.length > 2) { this.addresses = roadNumber; this.roadSize = 1 }
    })
  }

  dawaBy(zip) {
    this.httpClient.get('https://dawa.aws.dk/postnumre/?nr=' + zip).subscribe((data: any) => {
      if (this.settings.show.manualCustomer) { this.form.customer.customerCity = data[0].navn }
      else if (this.settings.show.manualInvoice) { this.form.invoice.invoiceCity = data[0].navn }
      else { this.form.delivery.city = data[0].navn }
    })
}

  cityLookup() {
    if (this.settings.show.manualInvoice) {
      if (this.form.invoice.invoiceZipCode.length == 4) { this.dawaBy(this.form.invoice.invoiceZipCode) }
      else { this.form.invoice.invoiceAddress = ''; }
    }
    else if (this.settings.show.manualCustomer) {
      if (this.form.customer.customerZipCode.length == 4) { this.dawaBy(this.form.customer.customerZipCode) }
      else { this.form.customer.customerAddress = ''; }
    }
    else {
      if (this.form.delivery.zipCode.length == 4) { this.dawaBy(this.form.delivery.zipCode) }
      else { this.form.delivery.address = ''; }
    }
  }

}

export class Settings {
  public show = new ManualCustomer();
  public type = new FormType();
}

export class FormType {
  private _invoiceIsManual = false;
  private _deliveryIsManual = false;
  private _customerIsManual = false;

  public get invoiceIsManual() { return this._invoiceIsManual }
  public get deliveryIsManual() { return this._deliveryIsManual }
  public get customerIsManual() { return this._customerIsManual }

  public set customerIsManual(value: boolean) { this._customerIsManual = value }
  public set invoiceIsManual(value: boolean) { this._invoiceIsManual = value }
  public set deliveryIsManual(value: boolean) { this._deliveryIsManual = value }
  
  public reset() { this._deliveryIsManual = false; this._invoiceIsManual = false }
}

export class ManualCustomer {
  private _manualMode = false;
  private _manualCustomerAddress = false;
  private _manualInvoiceAddress = false;
  private _manualDeliveryAddress = false;
  private _sameAddress = true;
  private _alternateAddresses = false;

  public get manualCustomer() { return this._manualCustomerAddress }
  public get manualInvoice() { return this._manualInvoiceAddress }
  public get manualDelivery() { return this._manualDeliveryAddress }
  public get manualMode() { return this._manualMode }
  public get sameAddress() { return this._sameAddress }
  public get alternateAddresses() { return this._alternateAddresses }

  public set manualCustomer(value: boolean) {
    this._manualCustomerAddress = value;
    if (value == true) {
      this.manualInvoice = false;
      this.manualDelivery = false;
    }
  }
  public set manualInvoice(value: boolean) {
    this._manualInvoiceAddress = value;
    if (this._manualInvoiceAddress == true) {
      this.manualCustomer = false;
      this.manualDelivery = false
    }
  }
  public set manualDelivery(value: boolean) {
    this._manualDeliveryAddress = value;
    if (this._manualDeliveryAddress == true) {
      this.manualInvoice = false;
      this.manualCustomer = false;
    }
  }
  public set manualMode(value: boolean) { this._manualMode = value }
  public set sameAddress(value: boolean) { this._sameAddress = value }
  public set alternateAddresses(value: boolean) { this._alternateAddresses = value }


  public reset() {
    this._manualMode = false;
    this._manualInvoiceAddress = false;
    this._manualDeliveryAddress = false;
    this._sameAddress = true;
    this._alternateAddresses = false;
  }
}

export class CustomerChangeForm {
  customerId: string = null;
  deliveryId: string = null;
  delivery = new Address();
  customer = new ChangeCustomer();
  invoice = new InvoiceAddress();
}

export class InvoiceAddress {
  invoiceName: string = '';
  invoiceNumber: string = '';
  invoiceAddress: string = '';
  invoiceZipCode: string = '';
  invoiceCity: string = '';
  invoiceMobile: string = '';
  invoiceEmail: string = '';
}

export class Address {
  public name: string = '';
  public address: string = '';
  public city: string = '';
  public zipCode: string = '';
  public mobile: string = '';
  public email: string = '';
}

export class ChangeCustomer {
  public customerName: string = '';
  public customerNumber: string = '';
  public customerAddress: string = '';
  public customerZipCode: string = '';
  public customerCity: string = '';
  public customerMobile: string = '';
  public customerEmail: string = '';
}

export class DAWA {
  public adresse: Addresser;
  public tekst: string;
}

export class Addresser {
  public adgangsadresseid: string;
  public adresseringsvejnavn: string;
  public darstatus: number;
  public dør: string;
  public etage: string;
  public href: URL;
  public husnr: string;
  public id: string;
  public kommunekode: string;
  public postnr: string;
  public postnrnavn: string;
  public status: number;
  public stormodtagerpostnr: string;
  public stormodtagerpostnrnavn: string;
  public supplerendebynavn: string;
  public vejkode: string;
  public vejnavn: string;
  public x: any;
  public y: any;
}

